<template>
  <div v-if="items.length" class="col-12">
    <div class="row mb-md-2">
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            Show&nbsp;
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="mx-1"
            ></b-form-select
            >&nbsp;entries
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div
          id="tickets-table_filter"
          class="dataTables_filter text-md-right"
        >
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
    </div>
    <b-table
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :filter="filter"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
      :show-empty="true"
      responsive
    >

    <template v-slot:table-colgroup="scope">
      <col
        v-for="field in scope.fields"
        :key="field.key"
        :style="{ width: field.key === 'actions' ? '50px' : '' }"
      >
    </template>

      <template v-slot:cell(actions)="row">

        <button
          class="btn btn-soft-primary btn-sm mx-1 mb-1"
          @click="$emit('onClick', row.item)"
        >
          <i class="uil uil-eye"></i>
        </button>
      </template>

      <template v-slot:cell(name)="row">
        <router-link
          tag="a"
          class="h6 m-0 table_link table_name_link_width"
          to=""
          @click.native="$emit('onClick', row.item)"
        >
          {{ row.item.name }}
        </router-link>
      </template>

      <template v-slot:cell(created_at)="row">
        <div>{{ row.item.created_at | date }}</div>
      </template>

      <template v-slot:cell(url)="row">
        <a
          :href="row.item.url"
          class="table_link table_url_width"
          target="_blank"
        >
          {{ row.item.url }}
        </a>
      </template>

    <!--   <template v-slot:cell(present_company)="row">
        <div>{{row.item.candidate_id.present_company}}</div>
      </template>-->
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      

    </b-table>
    <div class="row">
      <div class="col">
        <div
          class="dataTables_paginate paging_simple_numbers float-right"
        >
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    No available job(s) in hrflow.
  </div>
</template>

<script>
import moment from 'moment/moment'

export default {
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isBusy:false,
      items: [],
      defaultValues: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'reference', label: 'Reference' },
        { key: 'url', label: 'URL' },
        {
          key: 'created_at',
          label: 'Created At',
          formatter: (value) => {
            return value ? moment(value).format('YYYY-MM-DD') : 'N/A'
          }
        },
        { key: 'actions', label: '' }
      ],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortDesc: false,
			sortBy: '',
    }
  },
  computed: {
    rows() {
      return this.totalRows || 1;
    }
  },
  methods: {
    onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    onMountJobs() {
      let parameters = this.parameters || {}
      
      if (parameters && parameters.data) {
        let { data, meta } = parameters.data
        this.items = [ ...data.jobs ]
        this.defaultValues = [ ...data.jobs ]

        this.totalRows = meta.maxPage
        this.currentPage = meta.page
      }
    }
  },
  filters:{
    date:function(v){
      return v ? moment(v).format('MMM DD, YYYY') : 'N/A'
    }
  },
  mounted() {
    this.onMountJobs();
  },
  watch: {
    filter: {
      handler: function() {
        let items = this.items || [];
        let filter = this.filter || ''

        if (filter && filter != '') {
          this.items = items.filter(val => {
            return val.name.toLowerCase().indexOf(filter) != -1 || val.reference.toLowerCase().indexOf(filter) != -1
          })
        }
        else {
          this.items = this.defaultValues
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .table_name_link_width {
    width: 150px;
  }
  
  .table_url_width {
    width: 100px;
  }

  .table_link {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>